module.exports = __webpack_public_path__ + "banquet/components/StoreFeedLayout/images/list_chevron.f7e2f3cf46a92a81c2948fc17338a302.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreFeedLayout/images/list_chevron.png
// module id = 1694
// module chunks = 1